import { render, staticRenderFns } from "./right-sidebar.component.vue?vue&type=template&id=6230dbc2&"
import script from "./right-sidebar.component.vue?vue&type=script&lang=js&"
export * from "./right-sidebar.component.vue?vue&type=script&lang=js&"
import style0 from "./right-sidebar.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports